// src/utils/formatUserMath.js
// Pomocnicze funkcje do spójnego formatowania i parsowania odpowiedzi użytkownika.

/**
 * Normalizuje wpis użytkownika do LaTeX tak, by ładnie wyświetlał się w InlineMath:
 * - "a e k"  →  a \cdot 10^{k}
 * - "*", "·", "x"  →  \,\cdot\,
 * - "^-" → "^{ -… }"
 * - "." w liczbach → ","
 * - usuwa zbędne spacje
 */
export function normalizeUserMathToLatex(raw) {
  if (!raw) return "";
  let s = String(raw).trim().replace(/\s+/g, "");

  // zapis naukowy: a e k  →  a \cdot 10^{k}
  s = s.replace(
    /^(\d+(?:\.\d+)?)[eE](-?\d+)$/,
    (_, a, k) => `${a}\\,\\cdot\\,10^{${k}}`
  );

  // mnożenie: *, ·, x → \cdot (z drobnymi odstępami)
  s = s.replace(/(\*|·|x)/g, "\\,\\cdot\\,");

  // potęga ujemna: ^-k → ^{-k}
  s = s.replace(/\^-(\d+)/g, "^{-$1}");

  // kropka dziesiętna → przecinek
  s = s.replace(/\./g, ",");

  return s;
}

/**
 * Parsuje łańcuch wejściowy do postaci (mantysa, wykładnik) w notacji naukowej.
 * Akceptuje:
 *  - a·10^k
 *  - a*10^k
 *  - a 10^k (zapis z kropką środkową pominiętą, jeśli ktoś wpisze bez znaku)
 *  - a e k / aEk
 * Zwraca { mantissa:number, exponent:number } lub null.
 */
export function parseScientificString(input) {
  if (!input) return null;

  const s = String(input).replace(",", ".").replace(/\s+/g, "");

  // a·10^k / a*10^k / a10^k
  let m =
    s.match(/^(\d+(?:\.\d+)?)(?:\*|·)?10\^(-?\d+)$/) ||
    s.match(/^(\d+(?:\.\d+)?)10\^(-?\d+)$/);

  // a e k
  if (!m) m = s.match(/^(\d+(?:\.\d+)?)[eE](-?\d+)$/);

  if (!m) return null;
  const mantissa = Number(m[1]);
  const exponent = parseInt(m[2], 10);
  if (!isFinite(mantissa) || !Number.isInteger(exponent)) return null;

  return { mantissa, exponent };
}
